import React from 'react';
import { Zap, Shield, BadgeIndianRupee, Cpu, Users, Building2 } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  Zap: Zap,
  Shield: Shield,
  BadgeIndianRupee: BadgeIndianRupee,
  Cpu: Cpu,
  Users: Users,
  Building2: Building2
};

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-[#007897] font-semibold text-sm uppercase tracking-wider">Why Choose Us</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4">
            Why Nanda Diagnostics?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Experience healthcare excellence with our commitment to accuracy, technology, and patient care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon] || Zap;
            return (
              <div
                key={feature.id}
                className="group p-8 rounded-2xl bg-gray-50 hover:bg-gradient-to-br hover:from-[#007897] hover:to-[#3949ab] transition-all duration-500 hover:shadow-xl hover:shadow-[#007897]/20 hover:-translate-y-2"
              >
                <div className="w-14 h-14 bg-blue-100 group-hover:bg-white/20 rounded-xl flex items-center justify-center mb-6 transition-colors">
                  <Icon className="w-7 h-7 text-[#007897] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 group-hover:text-white mb-3 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-600 group-hover:text-blue-100 transition-colors">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
